export { default } from "./CardSmsSwitch";



// WEBPACK FOOTER //
// ./src/data-containers/CardSmsSwitch/index.js